import _uniqueId from 'lodash/uniqueId';
import { create } from 'zustand';
import { ToastData, ToastVariant } from '../../components/toast/types';

export type ToastStoreType = {
  toast: ToastData[];
  add: (text: string | { title: string; text: string }, variant?: ToastVariant) => void;
  remove: (id: string) => void;
};

export const useToastStore = create<ToastStoreType>(set => ({
  toast: [],
  add: (text, variant = 'info') => {
    set(state => ({
      ...state,
      toast: [
        ...state.toast,
        {
          id: _uniqueId('prefix-'),
          ...('string' === typeof text ? { text } : text),
          variant,
        },
      ],
    }));
  },
  remove: id =>
    set(state => ({
      ...state,
      toast: state.toast.filter(t => t.id !== id),
    })),
}));
